import * as AccessibleIcon from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

const Filter: React.FC<SVGProps<SVGSVGElement>> = props => {
  const label = 'filter-icon'
  return (
    <AccessibleIcon.Root label={label}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <path d="M10 14L4 5V3H20V5L14 14V20L10 22V14Z" fill="currentColor" />
      </svg>
    </AccessibleIcon.Root>
  )
}

export default Filter
